<template>
    <div class="billresult_page__container mt-3">
        <template v-if="payed">
            <div class="billresult_page__content flex flex-column align-items-center gap-6">
                <img src="/i/pages/billresult/success.webp" class="billresult_page__image_success" alt="" />
                <div class="flex flex-column align-items-center gap-3">
                    <span class="billresult_page__title">{{ $t('lang.billresult.success_title') }}</span>
                    <span class="billresult_page__message">{{ $t('lang.billresult.success_message') }}</span>
                </div>
                <div class="flex flex-column align-items-center gap-3">
                    <div class="flex column-gap-2 row-gap-3 flex-column sm:flex-row">
                        <Button
                            icon="pi pi-arrow-up-right"
                            iconPos="right"
                            @click="onOpenMain"
                            :label="$t('lang.billresult.button_main')"
                        />
                        <Button
                            icon="ksi ksi-user-main"
                            iconPos="right"
                            @click="onOpenPanel"
                            outlined
                            :label="$t('lang.billresult.button_panel')"
                            :pt="{
                                root: {class: 'bg-white', style: {padding: '10px 1.5rem'}},
                                icon: {class: 'text-2xl'}
                            }"
                        />
                    </div>
                </div>
            </div>
        </template>
        <template v-else>
            <div class="billresult_page__image_preloader hidden sm:block" :class="{'success': successPayed}"></div>
            <div class="billresult_page__content flex flex-column gap-6">
                <div class="flex flex-column align-items-center gap-3">
                    <span class="billresult_page__title">{{ $t('lang.billresult.waiting_title') }}</span>
                    <span class="billresult_page__message">{{ $t('lang.billresult.waiting_message') }}</span>
                    <span class="billresult_page__dots">{{ $t('lang.billresult.waiting_dots') }}</span>
                </div>
                <div class="flex flex-column align-items-center gap-3">
                    <div class="flex column-gap-2 row-gap-3 flex-column sm:flex-row">
                        <Button
                            icon="pi pi-arrow-up-right"
                            iconPos="right"
                            @click="onOpenMain"
                            :label="$t('lang.billresult.button_main')"
                        />
                        <Button
                            icon="ksi ksi-user-main"
                            iconPos="right"
                            @click="onOpenPanel"
                            outlined
                            :label="$t('lang.billresult.button_panel')"
                            :pt="{
                                root: {class: 'bg-white', style: {padding: '10px 1.5rem'}},
                                icon: {class: 'text-2xl'}
                            }"
                        />
                    </div>
                    <span class="billresult_page__desc">{{ $t('lang.billresult.waiting_desc') }}</span>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import Button from "primevue/button";
import WindowResize from "keysso/mixins/WindowResize";
import PaymentApi from "keysso/api/PaymentApi";
import {AppConstant} from "keysso/app.constant";
import Alerts from "keysso/mixins/Alerts";

export default {
    name: "BillResultPage",
    mixins: [WindowResize, Alerts],
    props: {
        /**
         * @type {{
         *     id: number,
         *     payed: boolean,
         *     // ...
         * }}
         */
        bill: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            payed: false,
            successPayed: false,
        }
    },
    mounted() {
        this.payed = this.bill.payed;
        if (!this.payed) {
            this.checkPayed();
        }
    },
    methods: {
        onOpenMain() {
            window.open(sprintf('/%s/', window.locale));
        },
        onOpenPanel() {
            window.open(sprintf('/%s/panel', window.locale));
        },
        onSuccess() {
            this.successPayed = true;
            if (this.isMobile) {
                this.payed = !this.payed;
                return;
            }

            // у комповской версии есть еще анимация об успешном получении оплаты. сделано только для неё!
            setTimeout(() => {
                this.payed = !this.payed;
            }, 2500);
        },
        checkPayed() {
            PaymentApi
                .getBillState(this.bill.id)
                .then(response => {
                    if (response.payed) {
                        this.onSuccess();
                        return;
                    }

                    setTimeout(this.checkPayed, AppConstant.TIMEOUT_WAITER_REQUEST);
                })
                .catch(error => this.alertError(error));
        },
    },
    components: {
        Button,
    },
}
</script>

<style scoped>
.billresult_page__container {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex-direction: column;
    min-height: 50vh;
    position: relative;
}
.billresult_page__image_preloader {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-image: url('/i/pages/billresult/animation-check.gif');
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    z-index: 1;
}
.billresult_page__image_preloader.success {
    background-image: url('/i/pages/billresult/animation-success.gif');
}
.billresult_page__image_success {
    max-width: 178px;
}
.billresult_page__content {
    background-color: #ffffffd1;
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
    border-radius: 16px;
    padding: 16px;
    max-width: 650px;
    z-index: 2;
}
.billresult_page__title {
    color: #212121;
    font-size: 36px;
    line-height: 1.2;
    font-weight: 700;
    text-align: center;
}
.billresult_page__message {
    color: #36393C;
    font-size: 18px;
    text-align: center;
}
.billresult_page__dots {
    color: #4B8400;
    font-size: 24px;
    line-height: 1.5;
    font-weight: 700;
}
.billresult_page__dots::after {
    content: '';
    display: inline-block;
    width: 1ch; /* ширина одной точки */
    text-align: left;
    animation: dots 1.2s steps(3, end) infinite;
}
.billresult_page__desc {
    color: #334155;
    text-align: center;
}

@keyframes dots {
    0%, 20% {
        content: '';
    }
    40% {
        content: '.';
    }
    60% {
        content: '..';
    }
    80%, 100% {
        content: '...';
    }
}
</style>
